/**
 * @internal
 */
import { AxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * Generic HttpResponse wrapper for AxiosResponse
 *
 * @internal
 */
export class HttpResponse<T> implements AxiosResponse {
	public data: T;
	public status: number;
	public statusText: string;
	public headers: any;
	public config: AxiosRequestConfig;

	constructor(ax: AxiosResponse) {
		this.data = ax.data;
		this.status = ax.status;
		this.statusText = ax.statusText;
		this.headers = ax.headers;
		this.config = ax.config;
	}
}
